var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppPage',{attrs:{"name":'miaosha'}},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"miaosha-content p-rel"},[_c('GoodsTab')],1)])]),_c('div',{staticClass:"ml-20"}),_c('div',{staticClass:"side"},[_c('AppQRCode'),_c('VideoIntro'),_c('AppComment'),_c('ContactUs'),_c('Copyright')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }